import { Link } from 'react-router-dom'

import { AcornsLogo } from '@acorns/web-components'
import styled, { css } from 'styled-components'

import theme from 'theme'

// This is for the small desktop breakpoint we would like to use going forward.
// keeping this in here rather than web app as a discussion here: https://github.com/Acornsgrow/web-core/pull/868
export const CUSTOM_SMALL_DESKTOP = 1050

const AcornsLogoContainer = styled.div`
  padding-bottom: 65px;
  padding-top: 35px;
`

const StyledAcornsLogo = styled(AcornsLogo)`
  margin: 0 15px;
  @media (max-width: ${theme.breakpoints.md}px) {
    margin: 0 10px;
    display: flex;
    justify-content: center;
  }
`

const ProductLink = styled(Link)<{ activeProduct?: boolean }>`
  align-items: center;
  color: ${theme.colors.slate};
  cursor: pointer;
  display: flex;
  margin-bottom: 10px;
  padding: 15px 37px 15px 15px;
  position: relative;
  text-decoration: none;
  width: 100%;
  z-index: 500;

  &:hover {
    opacity: 70%;
  }

  @media (max-width: ${theme.breakpoints.md}px) {
    padding: 5px 10px;
    justify-content: center;
    margin-bottom: 20px;
    min-height: 54px;
    width: 54px;
    flex-direction: column;
  }

  ${(props) =>
    props.activeProduct &&
    css`
      background: ${theme.colors.ivory};
      border-radius: ${theme.borderRadius.large};
    `}
`

const ProductTitle = styled.div<{ isBottomElement: boolean }>`
  line-height: 22px;
  font-weight: 600;
  font-size: 14px;
  padding-left: 15px;
  padding-right: ${(props) => (props.isBottomElement ? '0px;' : '10px')};

  @media (max-width: ${theme.breakpoints.md}px) {
    text-align: center;
    padding-left: ${(props) => (props.isBottomElement ? '0px;' : '15px')};
    padding-right: ${(props) => (props.isBottomElement ? '0px;' : '15px')};
    font-size: 10px;
    line-height: 14px;
    margin-top: 6px;
  }
`

const Balance = styled.div`
  line-height: 22px;
  font-weight: 600;
  position: absolute;
  right: 15px;
  font-size: 14px;
  @media (max-width: ${CUSTOM_SMALL_DESKTOP}px) {
    display: none;
  }
`
export {
  AcornsLogoContainer,
  Balance,
  ProductLink,
  ProductTitle,
  StyledAcornsLogo,
}
